/******************************
 * GENERATED FILE, DO NOT EDIT *
 *******************************/ import type {
  ReactNode,
  SVGProps,
} from "react";
export default function IconMagnifierCheck(
  props: SVGProps<SVGSVGElement>
): ReactNode {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      fill="none"
      viewBox="0 0 21 21"
      color="currentColor"
      {...props}
    >
      <path
        fill="currentColor"
        d="M14.11 7.858a.601.601 0 1 0-.869-.832l-4.18 4.368-1.848-2.071a.601.601 0 0 0-.898.8l2.28 2.558a.6.6 0 0 0 .884.015z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M.116 10.466c0-5.342 4.33-9.672 9.671-9.672 5.342 0 9.672 4.33 9.672 9.672a9.64 9.64 0 0 1-2.42 6.4l2.9 2.9a.602.602 0 0 1-.85.85l-2.9-2.9a9.64 9.64 0 0 1-6.402 2.422c-5.341 0-9.671-4.33-9.671-9.672m9.671-8.47a8.469 8.469 0 1 0 0 16.939 8.469 8.469 0 0 0 0-16.938"
        clipRule="evenodd"
      />
    </svg>
  );
}
